<template>
  <div>
    <section>
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.reference')"/>
        <div class="form-row">
          <div class="col-md-6">
            <label>{{ $t('message.type') }}</label>
            <select
              :disabled="true"
              v-model="form.ref_type"
              class="form-control form-control-sm custom-select">
              <option value="po">{{ $t('documents.po') }}</option>
              <option value="so">{{ $t('documents.so') }}</option>
              <option value="in">{{ $t('documents.in') }}</option>
              <option value="ex">{{ $t('documents.ex') }}</option>
              <option value="prl">{{ $t('documents.prl') }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <template>
              <label>{{ $t('message.series') }}</label>
            </template>
            <select
              :disabled="true"
              class="form-control form-control-sm custom-select">
              <option>{{ form.ref_code }}</option>
            </select>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="col-md-12 no-padding">
        <template>
          <section-title :title="sectionHeaderRefCode"/>
          <div class="form-row">
            <div
              v-if="form.ref_type == 'po' || form.ref_type == 'in'"
              class="col-md-6">
              <template v-if="form.ref_type == 'po'">
                <label>{{ $t('message.vendor') }}</label>
                <input
                  :disabled="true"
                  :value="form.partner.vendor ? form.partner.vendor.vendor_name : ''"
                  type="text"
                  class="form-control form-control-sm">
              </template>
              <template v-if="form.ref_type == 'in'">
                <label>{{ $t('message.customer') }}</label>
                <input
                  :disabled="true"
                  :value="form.partner.customer ? form.partner.customer.customer_name : ''"
                  type="text"
                  class="form-control form-control-sm">
              </template>
            </div>
            <div class="col-md-6">
              <label>{{ $t('message.debttotal') }}</label>
              <input
                v-if="docInfo.po"
                :disabled="true"
                :value="getDebtPurchaseAmount(docInfo.po)"
                type="text"
                class="form-control form-control-sm text-info">
              <input
                v-if="docInfo.ex"
                :disabled="true"
                :value="getDebtExpenseAmount(docInfo.ex)"
                type="text"
                class="form-control form-control-sm text-info">
              <input
                v-if="docInfo.in"
                :disabled="true"
                :value="getDebtInvoiceAmount(docInfo.in)"
                type="text"
                class="form-control form-control-sm text-info">
              <input
                v-if="docInfo.prl"
                :disabled="true"
                :value="getDebtPayslipAmount(docInfo.prl)"
                type="text"
                class="form-control form-control-sm text-info">
            </div>
          </div>
        </template>
      </div>
    </section>
    <section class="mb-0">
      <div class="col-md-12 no-padding">
        <section-title :title="$t('message.infopayment')"/>
        <div class="form-row mb-2">
          <div class="col-md-6">
            <label>{{ $t('message.type') }}</label>
            <select
              v-model="form.pe_type"
              class="form-control form-control-sm custom-select">
              <option value="cash">{{ $t('message.cash') }}</option>
              <option value="card">{{ $t('message.creditcard') }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label>{{ $t('message.paidamount', {string: currency}) }}</label>
            <input
              ref="pe_amount"
              :class="[bindClass.pe_amount]"
              v-model="form.pe_amount"
              type="text"
              class="form-control form-control-sm number-only text-select-all"
              @keypress="numberOnly"
              @keyup="form.pe_amount = setToValidNumber(form.pe_amount)"
              @blur="form.pe_amount = setToCustomDigitsNumber(form.pe_amount)">
          </div>
        </div>
        <div class="form-row mb-3">
          <div class="col-12">
            <textarea
              :placeholder="$t('placeholder.note')"
              v-model="form.pe_note"
              class="form-control form-control-sm"
              style="min-height: 90px;"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12">
            <vs-checkbox
              v-model="form.pe_ispaid"
              color="#A3CA76"
              style="float: left;position: relative;top: 0;left: -5px;">
              {{ $t('message.ispaid') }}
            </vs-checkbox>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    po: {
      type: Object,
    },
    so: {
      type: Object,
    },
    in: {
      type: Object,
    },
    ex: {
      type: Object,
    },
    prl: {
      type: Object,
    },
    amount: {
      type: Number,
      required: true,
    },
    validation: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      form: {
        ref_type: '',
        ref_code: '',
        pe_type: 'cash',
        pe_amount: '',
        pe_date: new Date(),
        pe_note: '',
        pe_ispaid: false,
        partner: {
          customer: null,
          vendor: null,
        },
      },
      bindClass: {
        pe_date: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      currency: 'getCurrency',
    }),
    docInfo () {
      if (this.form.ref_type == 'po') {
        return {
          po: this.po,
        }
      }
      if (this.form.ref_type == 'ex') {
        return {
          ex: this.ex,
        }
      }
      if (this.form.ref_type == 'in') {
        return {
          in: this.in,
        }
      }
      if (this.form.ref_type == 'prl') {
        return {
          prl: this.prl,
        }
      }
      return {}
    },
    sectionHeaderRefCode () {
      if (this.form.ref_type == 'po') {
        return this.po.po_code
      }
      if (this.form.ref_type == 'ex') {
        return this.ex.ex_code
      }
      if (this.form.ref_type == 'in') {
        return this.in.in_code
      }
      if (this.form.ref_type == 'prl') {
        return this.prl.prlCode
      }
      return null
    },
  },
  watch: {
    validation () {
      this.validateform()
    },
    'form.pe_amount': {
      handler: function () {
        this.isValid()
      },
      deep: true,
    },
  },
  created: function () {
    // set ref
    if (this.po) {
      this.form.ref_type = 'po'
      this.form.ref_code = this.po.po_code
      this.form.partner.vendor = this.po.vendor ? this.po.vendor : null
    } else if (this.so) {
      this.form.ref_type = 'so'
      this.form.ref_code = this.so.so_code
    } else if (this.in) {
      this.form.ref_type = 'in'
      this.form.ref_code = this.in.in_code
      this.form.partner.customer = this.in.customer ? this.in.customer : null
    } else if (this.ex) {
      this.form.ref_type = 'ex'
      this.form.ref_code = this.ex.ex_code
    } else if (this.prl) {
      this.form.ref_type = 'prl'
      this.form.ref_code = this.prl.prlCode
    }
    // default amount
    if (this.amount != undefined) {
      this.form.pe_amount = this.setToCustomDigitsNumber(this.amount)
    }
  },
  methods: {
    isValid () {
      let val = parseFloat(this.form.pe_amount)
      var isValid = true
      if (isNaN(val)) {
        isValid = false
      }
      if (isValid) {
        this.bindClass.pe_amount = ''
      } else {
        this.bindClass.pe_amount = 'is-invalid'
      }
      return isValid
    },
    validateform () {
      var isValid = false
      var data = null
      if (this.isValid()) {
        isValid = true
        data = {
          type: this.form.pe_type,
          amount: this.form.pe_amount,
          status: this.form.pe_ispaid ? 'paid' : 'padding',
          note: this.form.pe_note.trim().length > 0 ? this.form.pe_note.trim() : null,
          partner: {
            customer_id: this.form.partner.customer ? this.form.partner.customer.customer_id : null,
            vendor_id: this.form.partner.vendor ? this.form.partner.vendor.vendor_id : null,
          },
        }
      }
      this.$emit('submit', isValid, data)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/FormPaymentEntry.vue